export class User {
  poid: string;
  lastLogin: number;
  settings: object;

  constructor() {
    this.settings = {};
  }
}
